import React, { Component } from "react";
// import Popup from "reactjs-popup";
import "./styles.css";
import "antd/dist/antd.css";
// import { Modal, Button } from "antd";
import HorizontalAdComponent from "./HorizontalAdComponent";

class HorizontalAdPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      setIsModalVisible: true,
    };
  }

  handleCancel = () => {
    this.setState({ setIsModalVisible: false });
    
  };

  // const modalStyle = () => ({
  //   display: setIsModalVisible ? "block" : "hide",
  //   visibility: setIsModalVisible ? "visible" : "hidden",
  // });

  render() {
    
    const adAppears = this.state.setIsModalVisible ? (
      <div className="modalPopupAd">
        <div className="close" onClick={this.handleCancel}>
          &times;
        </div>
        <HorizontalAdComponent
          dataAdClient={this.props.dataAdClient}
          dataAdSlot={this.props.dataAdSlot}
        />
      </div>
    ) : (
      <div />
    );
    return (
      <div>
        <div
          style={{
            position: "fixed",
            bottom: 0,
            width: "100%",
            zIndex: 10000,
          }}
        >
        {adAppears}
        </div>
        {/* 
      <Modal
        className="modalPopupAd"
        visible={isModalVisible}
        // footer={null}
        onCancel={handleCancel}
        maskClosable={false}
        keyboard={false}
        width="90%"
        mask={false}
        footer={null}
        zIndex={10000}
      >
        <p>
          Some contents...Some contents...Some contents...Some contents...Some
          contents...Some contents...Some contents...Some contents...Some
          contents...Some contents...Some contents...Some contents...Some
          contents...Some contents...Some contents...Some contents...Some
          contents...Some contents...
        </p>
        <div style={{ minHeight: "120px" }}>
          <HorizontalAdComponent
            dataAdClient="ca-pub-1920730948516638"
            dataAdSlot="5692826525"
          />
        </div>
      </Modal> */}
        {/* <Button type="primary" onClick={showModal}>
        Open Modal
      </Button>
      <Modal
        title="Basic Modal"
        visible={isModalVisible}
        // onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>Some contents...</p>
        <p>Some contents...</p>
        <p>Some contents...</p>
      </Modal> */}
      </div>
    );
  }
}

export default HorizontalAdPopup;


// WEBPACK FOOTER //
// ./src/components/ads/HorizontalAdPopup.js